import { AppState } from 'redux/reducers';

export const getNextRaces = ({ nextRaces }: AppState) => nextRaces.races;
export const getIsRacesLoading = ({ nextRaces }: AppState) => nextRaces.loading;
